"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToMailingList = void 0;
const addToMailingList = async (email, tags) => {
    const response = await fetch("https://us9.api.mailchimp.com/3.0/lists/d53d00f0e0/members/", {
        body: JSON.stringify({
            email_address: email,
            tags: tags,
            status: "subscribed",
            statusIfNew: "subscribed",
        }),
        headers: {
            "Content-Type": "application/json",
            Authorization: "apikey ce7b00bf9a31e071fd7c5b2fb9871b15-us9",
        },
        method: "POST",
    });
    const pay_response = await response.json();
    return pay_response;
};
exports.addToMailingList = addToMailingList;
